// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"4774":"c1383c32","7983":"ced742c3","9086":"963f27a7"}[chunkId] + ".css";
};